import classNames from 'classnames';
import { MdCalendarToday, MdPerson } from 'react-icons/md';
import ItemDetailsInfo from 'components/ItemDetailsInfo';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import Text from './typography/Text';

export default function ItemDetails({
  className,
  title,
  location,
  componentName,
  date,
  guest,
  totalPrice,
  due,
  balanceDueDate,
  reference,
  isHorizontal,
  componentType,
  type,
  isLoyaltyBooking,
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <div className={className}>
      <div className="lg:flex lg:justify-between">
        <div className="my-2">
          <Text className="font-bold text-xl">{title}</Text>
          <Text className="text-gray-500 font-medium">{location}</Text>
          <Text className="text-gray-500 font-medium">
            Reference: {reference}
          </Text>
        </div>
        {isHorizontal && (
          <div className="flex flex-col items-end">
            <div className="hidden md:flex lg:flex items-center space-x-2">
              <div className="text-[16px] text-gray-500 lg:mt-1">Total</div>
              <Text className="font-medium text-[20px] md:text-[20px]">
                {totalPrice}
              </Text>
            </div>
            {type !== 'quote' && due && balanceDueDate && (
              <Text className="text-gray-500 font-medium">
                {due ? `Balance ${due}` : ''}
                {due && balanceDueDate && balanceDueDate !== '-'
                  ? ` due ${balanceDueDate}`
                  : ''}
              </Text>
            )}
          </div>
        )}
      </div>
      <div className={classNames({ 'lg:mb-3 lg:flex': isHorizontal })}>
        <ItemDetailsInfo
          className={classNames('pl-1', {
            'lg:w-[35%]': isHorizontal,
            'mb-5': !isHorizontal,
          })}
          icon={
            <div className="text-2xl">
              <QuoteBookingComponentIcon
                componentType={componentType}
                fillColor={primaryColour}
              />
            </div>
          }
          label={componentName}
        />
        <ItemDetailsInfo
          className={classNames('pl-1', {
            'lg:w-[35%]': isHorizontal,
            'mb-5': !isHorizontal,
          })}
          icon={isLoyaltyBooking ? null : <MdCalendarToday style={{ fill: primaryColour }} />}
          label={isLoyaltyBooking ? null : date}
        />
        <ItemDetailsInfo
          iconClassName="ml-1"
          className={classNames({
            'lg:w-[30%]': isHorizontal,
            'mb-5': !isHorizontal,
          })}
          icon={isLoyaltyBooking ? null : <MdPerson style={{ fill: primaryColour }} />}
          label={isLoyaltyBooking ? null : guest}
        />
      </div>
      <div className={classNames({ 'lg:hidden': isHorizontal })}>
        <div className="text-base mr-1 text-gray-500 font-medium">Total</div>
        <Text className="font-medium text-[20px] md:text-[20px]">
          {totalPrice}
        </Text>
      </div>
    </div>
  );
}
